import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";
import RegularShape from "ol/style/RegularShape";
import { rgb } from "d3";

export const defaultTextStyle = (text) => {
  return new Text({
    offsetY: 14,
    fill: new Fill({
      color: "#000",
    }),
    stroke: new Stroke({
      color: "#FFF",
      width: 3,
    }),
    text: text,
    font: "12px sans-serif",
    backgroundFill: new Fill({
      color: "rgba(255, 255, 255, 0.1)",
    }),
  });
};

export const countStyle = (count, radius, fill) => {
  const countSize = count.toString().length > 3 ? radius * 0.7 : radius - 1;

  return new Text({
    fill: new Fill({
      color: "#fff",
    }),
    text: count.toString(),
    backgroundFill: new Fill({
      color: fill,
    }),
    font: `bold ${Math.round(countSize)}px sans-serif`,
    padding: [2, 0, 2, 0],
  });
};

export const hoverStyle = (feature) => {
  const fill = feature.get("fill") || "#6a3d9a";
  const stroke = feature.get("stroke") || fill;
  const radius = feature.get("radius") || 6;
  const name = (feature.get("name") || "").substr(0, 14);

  console.log(fill, stroke, radius, name);
  // let newStyle = oldStyle.clone();
  let newStyle = new Style();

  newStyle.setFill(
    new Fill({
      color: rgb(fill).brighter(0.5).toString(),
    })
  );
  newStyle.setStroke(
    new Stroke({
      color: rgb(stroke).brighter(0.5).toString(),
      width: 3,
    })
  );
  newStyle.setText(defaultTextStyle(name));
  return newStyle;
};

export const starStyle = (config = {}) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color: config.color || [238, 218, 20, 1],
      }),
      stroke: new Stroke({
        color: config.color || [238, 218, 20, 1],
        width: 1,
      }),
      points: config.points || 5,
      radius: config.radius,
      radius2: config.radius * 0.4,
      angle: 0,
    }),
  });
};

export const hiddenStyle = new Style({ opacity: 0 });

export const simplePointStyle = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new Circle({
      radius,
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
    }),
    text: defaultTextStyle(name),
  });
};

export const simpleSquareStyle = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 4,
      radius,
      angle: Math.PI / 4,
    }),
    text: defaultTextStyle(name),
  });
};

export const simpleDiamondStyle = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 4,
      radius,
    }),

    text: defaultTextStyle(name),
  });
};

export const simpleRect1Style = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 4,
      radius,
      angle: Math.PI / 4,
      scale: [0.8, 1.5],
    }),

    text: defaultTextStyle(name),
  });
};

export const simpleRect2Style = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 4,
      radius,
      radius2: radius * 0.4,
      scale: [1, 1.3],
    }),

    text: defaultTextStyle(name),
  });
};

export const simpleRect3Style = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 4,
      radius,
      angle: Math.PI,
      scale: [1, 1.3],
    }),

    text: defaultTextStyle(name),
  });
};

export const simpleTriangle1Style = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 3,
      radius,
      angle: Math.PI,
    }),

    text: defaultTextStyle(name),
  });
};

export const simpleTriangle2Style = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 3,
      radius,
    }),

    text: defaultTextStyle(name),
  });
};

export const simplePentagonStyle = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 5,
      radius,
    }),

    text: defaultTextStyle(name),
  });
};

export const simpleStarStyle = (
  color,
  radius,
  border,
  opacity = 1,
  name = ""
) => {
  return new Style({
    image: new RegularShape({
      fill: new Fill({
        color,
        opacity: opacity,
      }),
      stroke: new Stroke({
        color: border || [217, 217, 210, 0.5],
        width: 1,
      }),
      points: 5,
      radius,
      radius2: radius * 0.4,
    }),

    text: defaultTextStyle(name),
  });
};

//styles for district points.

const parseName = (name = "") => {
  if (name.length <= 15) {
    return name;
  } else {
    return name.slice(0, 14) + "...";
  }
};

export const centroidStyle = (config = {}) => {
  let {
    count,
    radius,
    fill,
    stroke,
    name,
    showLabel,
    fillOpacity,
    opacity,
    strokeWidth,
    textSize,
    textFill,
    textStroke,
  } = config;

  // allows hideing of district
  if (opacity === 0) {
    console.log("hidden");
    return hiddenStyle;
  }

  if (!stroke) stroke = fill;
  if (!radius) radius = 5;

  // turn fillOpacity and fill hex color into rbga color
  if (fillOpacity) {
    console.log("fillOpacity", fillOpacity);
    let hexFill = Math.round(fillOpacity * 255);
    hexFill = (hexFill | (1 << 8)).toString(16).slice(1);
    fill = fill + hexFill;
  }

  return new Style({
    text: showLabel
      ? defaultTextStyle(!!showLabel && name)
      : !!count && countStyle(count, radius, fill),
    image: new Circle({
      radius,
      fill: new Fill({
        color: fill,
      }),
      stroke: new Stroke({
        color: stroke,
        width: strokeWidth || 1,
      }),
    }),
    zIndex: 10,
    // text: !!count && countStyle(count, radius)
  });
};

// used for when we have multiple text styles needed at once
export const svgCentroidStyle = (config = {}) => {
  let {
    count,
    radius,
    fill,
    stroke,
    name,
    showLabel,
    fillOpacity,
    opacity,
    strokeWidth,
    textSize,
    textFill,
    textStroke,
    innerTextFill,
  } = config;

  console.log(opacity);
  // allows hideing of district
  if (opacity === 0) {
    console.log("hidden");
    return hiddenStyle;
  }

  if (!stroke) stroke = fill;
  if (!radius) radius = 5;

  let ELEMENT_SIZE = 80;

  let svgstr = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                        x="0" y="0" width="${ELEMENT_SIZE}px" height="${
    ELEMENT_SIZE * 1.5
  }px" overflow="visible"
                        viewBox="-${ELEMENT_SIZE / 2} -${
    ELEMENT_SIZE / 2
  } ${ELEMENT_SIZE} ${ELEMENT_SIZE}">
                   <circle fill="${fill}" stroke="${stroke}" fill-opacity="${
    fillOpacity || 1
  }" stroke-width="${strokeWidth || 1}" r="${radius}"/>
                   <text style="; font: bold ${
                     (count || "").toString().length > 3
                       ? radius * 0.7
                       : radius - 1
                   }px sans-serif; line-height: ${radius}" 
                   fill="${innerTextFill || fill}"  text-anchor="middle" dy="${
    (count || "").toString().length > 3 ? radius * 0.3 : radius * 0.4
  }">
                            ${count || ""}
                    </text>
                    ${
                      showLabel
                        ? `<text letter-spacing="1"  style="font-size: ${
                            textSize || "9px"
                          }; font-family: sans-serif; font-weight: 200; line-height: 10px"  fill='${
                            textFill || fill
                          }' stroke="${textStroke || fill}" 
                        text-anchor="middle" dy="${
                          radius + 11 + radius * 0.1
                        }" opacity="1"
                    >${parseName(name)}</text>`
                        : ``
                    }
                </svg>`;

  let svg = new Image();
  svg.src = "data:image/svg+xml," + encodeURIComponent(svgstr);

  return new Style({
    image: new Icon({
      img: svg,
      opacity: 1,
      imgSize: [ELEMENT_SIZE, ELEMENT_SIZE * 1.5],
    }),
  });
};

export const crossStyle = (config = {}) => {
  let { radius, fill, stroke, strokeWidth } = config;

  if (!stroke) stroke = fill;
  if (!strokeWidth) strokeWidth = 4;
  if (!radius) radius = 9;

  let ELEMENT_SIZE = radius * 2;

  let svgstr = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                        x="0" y="0" width="${ELEMENT_SIZE}px" height="${
    ELEMENT_SIZE * 1.5
  }px" overflow="visible"
                        viewBox="0 0 20 20">
                   <line x1="0" y1="0" x2="20" y2="20" style="stroke:rgb(255,0,0);stroke-width:${strokeWidth}" />
                   <line x1="20" y1="0" x2="0" y2="20" style="stroke:rgb(255,0,0);stroke-width:${strokeWidth}" />
                </svg>`;

  let svg = new Image();
  svg.src = "data:image/svg+xml," + encodeURIComponent(svgstr);

  return new Style({
    zIndex: config.zIndex || 10,
    image: new Icon({
      img: svg,
      opacity: 1,
      imgSize: [ELEMENT_SIZE, ELEMENT_SIZE * 1.5],
    }),
  });
};

export const genericSquareStyle = (config) => {
  let { width, fill, stroke, opacity } = config;

  width = width || 6;
  opacity = opacity || 1;
  fill = fill || "#6a3d9a";
  stroke = stroke || fill;

  return new Style({
    zIndex: 10,
    image: new RegularShape({
      fill: new Fill({
        color: fill || [238, 218, 20, 1],
      }),
      stroke: new Stroke({
        color: fill || [238, 218, 20, 1],
        width: 1,
      }),
      points: 4,
      radius: width / 2,
      angle: 0,
    }),
  });
};

export const genericCircleStyle = (config) => {
  let { radius, fill, stroke, opacity, fillOpacity } = config;
  if (!radius) radius = 6;
  // if (!stroke) stroke = fill;
  let ELEMENT_SIZE = radius * 3;
  if (opacity === null || opacity > 1 || opacity < 0) opacity = 1;
  if (fillOpacity === null || fillOpacity > 1 || fillOpacity < 0)
    fillOpacity = 1;

  let svgstr = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                        x="0" y="0" width="${ELEMENT_SIZE}px" height="${ELEMENT_SIZE}px" 
                        viewBox="-${ELEMENT_SIZE / 2} -${
    ELEMENT_SIZE / 2
  } ${ELEMENT_SIZE} ${ELEMENT_SIZE}">
                   <circle fill="${fill}" fill-opacity="${fillOpacity}" stroke="${stroke}" opacity="${opacity}" r="${radius}"/>
                </svg>`;

  let svg = new Image();
  svg.src = "data:image/svg+xml," + encodeURIComponent(svgstr);

  return new Style({
    zIndex: 10,
    image: new Icon({
      img: svg,
      opacity: 1,
      imgSize: [ELEMENT_SIZE, ELEMENT_SIZE],
    }),
  });
};

export const coloredPolygonStyle = (color, strokeWidth, opacity) => {
  let rgbcolor = color ? rgb(color) : rgb("#173fb7");

  rgbcolor.opacity = opacity || (opacity === 0 ? 0 : 1);
  let strokecolor = rgbcolor.toString();

  rgbcolor.opacity = 0.1;
  let fillcolor = rgbcolor.toString();

  return new Style({
    stroke: new Stroke({
      color: strokecolor,
      width: strokeWidth || (strokeWidth === 0 ? 0 : 3),
    }),
    fill: new Fill({
      color: fillcolor,
    }),
  });
};

export const defaultStyle = centroidStyle({
  fill: "#6a3d9a",
  radius: 6,
});

export const defaultLineStringStyle = (config) => {
  return new Style({
    stroke: new Stroke({
      width: config.width || 2,
      color: config.stroke,
    }),
  });
};
